import { render } from "./MdChip.vue?vue&type=template&id=318e8896"
import script from "./MdChip.vue?vue&type=script&lang=js"
export * from "./MdChip.vue?vue&type=script&lang=js"

import "./MdChip.vue?vue&type=style&index=0&id=318e8896&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__